// ServicesSection.js
import React from 'react';
import { motion } from 'framer-motion';

const ServicesSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block bg-surface text-secondary text-sm font-light px-6 py-2 rounded-full mb-4">
              What We Do
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold text-primary">
              Two Routes, One Process
            </h2>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex items-center"
          >
            <p className="text-gray-600 text-sm font-light leading-relaxed">
              Ivipass helps people move abroad to study or to work. It starts with a conversation about your background and what you are actually eligible for, and continues through the shortlisting, the paperwork and the submission itself. You keep one point of contact the whole way, and you are told plainly when a route is not worth pursuing.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
